import Image from "next/image";
import DefaultImage from 'public/assets/default.png'
import PartnerImage from 'public/assets/partner.png'
import AirportImage from 'public/assets/airport.png'
import { Station } from "lib/api/backend.schemas";
export const StationImage = ({station, className}: {station: Station, className?: string}) => {
    return <Image
      src={station?.airportStation ? AirportImage.src : station?.partner ? PartnerImage.src : DefaultImage.src}
      height={station?.airportStation ? AirportImage.height : station?.partner ? PartnerImage.height : DefaultImage.height}
      width={station?.airportStation ? AirportImage.width : station?.partner ? PartnerImage.width : DefaultImage.width}
      alt=""
      className={className} />;
  }
  
  export default StationImage